import React from "react";

export const NotFoundPage = () => (
  <div>¡Ups! Página no encontrada</div>
)
